'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopNamespaceCompat(e) {
    if (e && typeof e === 'object' && 'default' in e) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceCompat(React);

const Svg20 = (props) => (React__namespace.createElement("svg", Object.assign({ width: 21, height: 21, viewBox: "0 0 21 21", fill: "none" }, props),
    React__namespace.createElement("path", { d: "M9.356 3.45a1 1 0 0 1 1.365 1.462L5.893 9.417q-.355.331-.613.578h13.714a1 1 0 1 1 0 2H5.216c.187.18.41.39.677.64l4.77 4.45a1 1 0 0 1-1.365 1.462l-4.817-4.495c-.546-.51-1.03-.961-1.367-1.376-.366-.45-.665-.979-.665-1.65 0-.672.3-1.202.665-1.65.337-.416.82-.867 1.367-1.376z", fill: props.fillColor, fillOpacity: 0.92 })));

exports.default = Svg20;
//# sourceMappingURL=20.js.map
